export const BASE_CLASS = `mt-SectionServices`
export const ARRAY_OFFSET = 1
export const TRACKS = {
  DETAIL_MODAL_OPEN: {
    event: 'Dealer Services Popup',
    data: {
      hit_origin: 'Detail Services Popup'
    }
  },
  STOCK_MODAL_OPEN: {
    event: 'Dealer Services Popup',
    data: {
      hit_origin: 'Dealer Information Services Popup'
    }
  },
  SERVICES_SEEN: {
    event: 'Dealer Services Seen'
  }
}

export const CONTEXTS = {
  STOCK: 'stock',
  STOCK_SUBSCRIPTION: 'stockSubscription',
  DETAIL: 'detail',
  DETAIL_SUBSCRIPTION: 'detailSubscription'
}
